import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { colors, spacing, fonts, breakpoints, fontSize } = redesignTheme;

export const useEbookReaderHeaderStyles = makeStyles(() => ({
  header: {
    height: 80,
    boxSizing: 'border-box',
    padding: spacing.md,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: colors.white,
    position: 'sticky',
    top: 0,
    zIndex: 30,
  },
  headerBackButton: {
    ...primaryButtonStyle,
    whiteSpace: 'nowrap',
    '& span': {
      fontFamily: fonts.opensansSemiBold,
      lineHeight: 1,
      display: 'block',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: '0 16px',
    },
  },
  headerBackIcon: {
    fontSize: 16,
    width: 16,
    height: 16,
    display: 'block',
    flexShrink: 0,
    color: colors.white,
  },
  profileWrapper: {
    position: 'relative',
  },
  profileButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    color: colors.overlay,
  },
  profileInitials: {
    width: 32,
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    fontSize: fontSize.sm,
    fontFamily: fonts.opensansBold,
    letterSpacing: 0.24,
  },
  profileName: {
    fontSize: fontSize.md,
    fontFamily: fonts.opensans,
    lineHeight: 1.6,
    whiteSpace: 'nowrap',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      display: 'none',
    },
  },
  profileIcon: {
    width: 16,
    height: 16,
    color: colors.overlay,
  },
}));
